import axios from '@/plugins/axios'
import { Module } from 'vuex'

const cloudinaryModule: Module<any, any> = {
    state: {},

    actions: {},

    mutations: {},
}

export default cloudinaryModule
